
<template>
<section>
  <div class="tabbed-content" :class="{disabled: (user.user_role == 'charity')}">
    <div class="columns">
      <div class="col">
        <chc-input v-model="data.disposition" :error="errors.disposition" label="Disposition" format="combo"
                   :autoCompleteValues="$store.state.constants.vehicle_donations.disposition" :disabled="!data.buyer"></chc-input>
        <chc-input v-model="data.date_sold_or_disposed" :error="errors.date_sold_or_disposed" label="Date Sold/Disposed" type="date" :disabled="!data.buyer"></chc-input>
        <chc-input v-model="data.date_title_received" :error="errors.date_title_received" label="Date Title Received" type="date"></chc-input>
        <chc-input v-model="data.improvement_description" :error="errors.improvement_description" label="Improvement Description" type="textarea"></chc-input>

        <div v-if ="user.user_role === 'admin'">
          <div v-if="!data.vdr_sent_date && data.can_send_vdr" class="field">
            <input type="submit" class="btn" value="Send VDR" @click="sendVdr">
          </div>
          <div v-if="data.vdr_sent_date && data.can_send_vdr" class="field">
            <dl class='data-sent'>
              <dt class="data-label">VDR Sent</dt>
              <dd class="data-content"> {{ data.vdr_sent_date }} </dd>
              <dd class="data-content"><a @click="sendVdr">Resend VDR</a></dd>
              <dd class="data-content"><a @click="downloadVdr"><span class="icon fal fa-file-pdf" aria-hidden="true"></span> Download VDR</a></dd>
            </dl>
          </div>
          <div v-if="hasMailErrors && errors.send_vdr" class="field">
              <span class="error-message">{{errors.send_vdr}}</span>
            </div>

          <div v-if="!data.vdc_sent_date" class="field">
            <input type="submit" class="btn" value="Send VDC" @click="sendVdc" :disabled="!data.can_send_vdc || !data.donor_has_email">
          </div>
          <div v-if="data.vdc_sent_date" class="field">
            <dl class="data-sent">
              <dt class="data-label">VDC Sent</dt>
              <dd class="data-content"> {{ data.vdc_sent_date }} </dd>
              <dd class="data-content" v-if="data.can_send_vdc"><a @click="sendVdc">Resend VDC</a></dd>
              <dd class="data-content"><a @click="downloadVdc"><span class="icon fal fa-file-pdf" aria-hidden="true"></span> Download VDC</a></dd>
            </dl>
          </div>
          <div v-if="!data.can_send_vdc" class="field">
            <span class="error-message" v-if="data.proceeds_distributed && data.sale_price_cents > 50000">Sale price must be $500 or less to send VDC</span>
            <span class="error-message" v-else>Cannot sent VDC until proceeds have been distributed</span>
          </div>
          <div v-if="data.can_send_vdc && !data.donor_has_email" class="field">
            <span class="error-message">No email in system for donor</span>
          </div>
          <div v-if="hasMailErrors && errors.send_vdc" class="field">
              <span class="error-message">{{errors.send_vdc}}</span>
            </div>

          <div v-if="!data['1098_sent_date']" class="field">
            <input type="submit" class="btn" value="Send 1098" @click="send1098" :disabled="!data.can_send_1098 || !data.donor_has_email">
          </div>
          <div v-if="data['1098_sent_date']" class="field">
            <dl class="data-sent">
              <dt class="data-label">1098 Sent</dt>
              <dd class="data-content"> {{ data['1098_sent_date'] }} </dd>
              <dd class="data-content" v-if="data.can_send_1098"><a @click="send1098">Resend 1098</a></dd>
              <dd class="data-content"><a @click="download1098"><span class="icon fal fa-file-pdf" aria-hidden="true"></span> Download 1098</a></dd>
            </dl>
          </div>
          <div v-if="!data.can_send_1098" class="field">
            <span class="error-message" v-if="!data.can_send_1098">{{errorDisplay1098}}</span>
          </div>
          <div v-if="data.can_send_1098 && !data.donor_has_email" class="field">
            <span class="error-message">No email in system for donor</span>
          </div>
          <div v-if="hasMailErrors && errors.send_1098" class="field">
              <span class="error-message">{{errors.send_1098}}</span>
            </div>

          <div class="field">
            <input type="submit" class="btn" value="Print Bill of Sale" @click="printBillOfSale">
          </div>

          <h3>Print Donor Documents</h3>
          <chc-checkbox v-model="print.vdr" label="VDR"></chc-checkbox>
          <chc-checkbox v-model="print.vdc" label="VDC"></chc-checkbox>
          <chc-checkbox v-model="print.ten_ninety_eight" label="1098"></chc-checkbox>
          <chc-checkbox v-model="print.envelope_label" label="#10 Envelope Label"></chc-checkbox>
          <div class="field">
            <input type="submit" class="btn" value="Print Selected Documents" @click="printSelectedDocuments">
          </div>
        </div>
      </div>
      <div class="col">
        <dl>
          <dt class="data-label">Buyer</dt>
          <dd class="data-content" :class="{ 'error-message' : !data.buyer }"> {{ (data.buyer) ? data.buyer: 'Select a buyer under processing' }} </dd>
        </dl>
        <h3 class="field">Buyer Payment</h3>
        <chc-input v-model="data.sale_price_cents" :error="errors.sale_price_cents" label="Sale Price" format="currency"></chc-input>
        <chc-input v-model="data.check_received_date" :error="errors.check_received_date" label="Check Received Date" type="date"></chc-input>
        <chc-input v-model="data.check_number" :error="errors.check_number" label="Check #"></chc-input>
        <chc-input v-model="data.deposit_date" :error="errors.deposit_date" label="Deposit Date" type="date"></chc-input>
        <chc-input v-model="data.auction_fee_cents" :error="errors.auction_fee_cents" label="Auction Fee" format="currency"></chc-input>
        <chc-input v-model="data.conditioning_fee_cents" :error="errors.conditioning_fee_cents" label="Miscellaneous Fee" format="currency"></chc-input>
        <dl>
          <dt class="data-label">Processing Fee</dt>
          <dd class="data-content"> {{ data.processing_fee }} </dd>
        </dl>
        <chc-input v-model="data.repair_cost_cents" :error="errors.repair_cost_cents" label="Repair Cost" format="currency"></chc-input>
        <h3 class="field">Towing Invoice</h3>
        <chc-input v-model="data.tow_fee_cents" :error="errors.tow_fee_cents" label="Tow Fee" format="currency"></chc-input>
        <div class="field columns">
          <dl>
            <dt class="data-label">Tow Fee Date Paid</dt>
            <dd class="data-content"> {{ data.tow_fee_paid }} </dd>
          </dl>
          <dl>
            <dt class="data-label">Tow Fee Check #</dt>
            <dd class="data-content"> {{ data.tow_fee_check_number }} </dd>
          </dl>
        </div>
        <div class="field">
          <dl>
            <dt class="data-label">Gross Adjusted Proceeds </dt>
            <dd class="data-content"> {{ data.gross_adjusted_proceeds }} </dd>
          </dl>
        </div>
        <div class="field">
          <input type="submit" class="btn" value="Distribute Proceeds"
            @click="distributeProceeds" :disabled="!buyerTransactionInfoComplete" v-if="user.user_role !== 'charity' && !data.no_updating">
            <p v-if="data.no_updating" class="success-message">Proceeds Distributed</p>
            <input type="submit" class="btn" value="Re-Distribute Proceeds"
            @click="distributeProceeds" :disabled="!buyerTransactionInfoComplete" v-if="user.user_role !== 'charity' && data.no_updating && !data.charity_proceeds_date_paid">
        </div>
        <h3>Charity Proceeds</h3>
        <div class="field">
          <dl>
            <dt class="data-label">Charity &percnt;</dt>
            <dd class="data-content"> {{ formatPercent(data.charity_percentage) }} </dd>
          </dl>
        </div>
        <div class="field">
          <dl>
            <dt class="data-label">Charity Proceeds</dt>
            <dd class="data-content"> {{ data.charity_proceeds }} <span v-if="data.proceeds_adjusted_for_min" class="error-message">(Adjusted for CHC Minimum Proceeds)</span></dd>
          </dl>
        </div>
        <div class="field columns">
          <dl>
            <dt class="data-label">Charity Proceeds Date Paid</dt>
            <dd class="data-content"> {{ data.charity_proceeds_date_paid }} </dd>
          </dl>
          <dl>
            <dt class="data-label">Charity Proceeds Check #</dt>
            <dd class="data-content"> {{ data.charity_proceeds_check_number }} </dd>
          </dl>
        </div>
        <div class="field">
          <dl>
            <dt class="data-label">CHC Proceeds </dt>
            <dd class="data-content"> {{ data.chc_proceeds }} <span v-if="data.proceeds_adjusted_for_min" class="error-message">(CHC Minimum Proceeds Applied)</span></dd>
          </dl>
        </div>
        <div class="field">
          <dl>
            <dt class="data-label">Including Processing Fee </dt>
            <dd class="data-content"> {{ data.proceeds_with_processing }} </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="columns" v-if="user.user_role !== 'charity'">
      <div class="col">
        <div class="field">
          <span v-if="hasErrors" class="error-message error-block">
            There were errors processing the form. Please fix the fields above.
          </span>
        </div>
        <div class="field">
          <input type="submit" class="btn" value="Save Changes"
                 @click="saveChanges">
        </div>
        <transition name="fade">
          <p v-if="saved" class="success-message">Changes Saved</p>
        </transition>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'
import helpers from '@/helpers'
import auth from '@/auth'

export default {
  name: 'VehicleDisposition',
  data () {
    return {
      user: auth.user,
      print: {
        vdr: false,
        vdc: false,
        ten_ninety_eight: false,
        envelope_label: false
      },
      saved: false,
      distributed: false,
      errors: {},
      hasErrors: false,
      hasMailErrors: false,
    }
  },
  props: ['data', 'vehicleId', 'refNum'],
  methods: {
    printSelectedDocuments () {
      if (this.user.user_role !== 'admin') return
      for (let key in this.print) {
        if (this.print.hasOwnProperty(key) && this.print[key]) {
          let data = { id: this.data.id }
          data[key] = true
          store.functions.vehicles.printDocuments(
            this.vehicleId, data,
            (errors) => {
              this.errors = errors
            }).then(response => {
            helpers.openAsPDF(response.data, this.refNum + '_' + key + '.pdf')
          })
        }
      }
    },
    sendVdr () {
      if (this.user.user_role !== 'admin') return
      store.functions.vehicles.sendVdr(this.vehicleId,
        this.data,
        (errors) => {
          this.errors = {
            send_vdr: errors
          }
          this.hasMailErrors = true
        }).then((response) => {
        this.$toast.success('VDR sent!')
        this.data.vdr_sent_date = response.data.vdr_sent_date
        this.hasMailErrors = false
      }).catch(() => {
        this.$toast.error('Failed to send VDR...')
      })
    },
    downloadVdr () {
      if (this.user.user_role !== 'admin') return
      store.functions.vehicles.downloadVdr(this.vehicleId,
        this.data,
        (errors) => {
          this.errors = errors
        }).then((response) => {
        helpers.openAsDownload(response.data, this.refNum + '_vdr.pdf')
      })
    },
    sendVdc () {
      if (this.user.user_role !== 'admin') return
      store.functions.vehicles.sendVdc(
        this.vehicleId, {
          id: this.data.id
        },
        (errors) => {
          this.errors = {
            send_vdc: errors
          }
          this.hasMailErrors = true
        }).then((response) => {
        this.$toast.success('VDC sent!')
        this.data.vdc_sent_date = response.data.vdc_sent_date
        this.hasMailErrors = false
      }).catch(() => {
        this.$toast.error('Failed to send VDC...')
      })
    },
    downloadVdc () {
      if (this.user.user_role !== 'admin') return
      store.functions.vehicles.downloadVdc(this.vehicleId,
        this.data,
        (errors) => {
          this.errors = errors
        }).then((response) => {
        helpers.openAsDownload(response.data, this.refNum + '_vdc.pdf')
      })
    },
    send1098 () {
      if (this.user.user_role !== 'admin') return
      store.functions.vehicles.send1098(
        this.vehicleId, {
          id: this.data.id
        },
        (errors) => {
          this.errors = {
            send_1098: errors
          }
          this.hasMailErrors = true
        }).then((response) => {
        this.$toast.success('1098 sent!')
        this.data['1098_sent_date'] = response.data['1098_sent_date']
        this.hasMailErrors = false
      }).catch(() => {
        this.$toast.error('Failed sending 1098...')
      })
    },
    download1098 () {
      if (this.user.user_role !== 'admin') return
      store.functions.vehicles.download1098(
        this.vehicleId,
        (errors) => {
          this.errors = errors
        }).then(response => {
        helpers.openAsDownload(response.data, this.refNum + '_1098c.pdf')
      })
    },
    printBillOfSale () {
      if (this.user.user_role !== 'admin') return
      let data = { id: this.data.id }
      data['bill_of_sale'] = true
      store.functions.vehicles.printDocuments(
        this.vehicleId, data,
        (errors) => {
          this.errors = errors
        }).then(response => {
        helpers.openAsPDF(response.data, this.refNum + '_bill_of_sale.pdf')
      })
    },
    distributeProceeds () {
      if (this.user.user_role !== 'admin') return
      this.distributed = false
      this.data.proceeds_distributed = true
      this.data.distribute_proceeds = true
      store.functions.vehicles.updateVehicleDispositionInfo(this.vehicleId, this.data, (errors) => {
        this.errors = errors
        this.hasErrors = true
        this.distributed = false
      }).then(() => {
        this.hasErrors = false
        this.errors = {}
        this.distributed = true
        this.$emit('refresh')
        setTimeout(() => {
          this.distributed = false
        }, 500)
      })
    },
    saveChanges () {
      if (this.user.user_role !== 'admin') return
      this.saved = false
      store.functions.vehicles.updateVehicleDispositionInfo(this.vehicleId, this.data, (errors) => {
        this.errors = errors
        this.hasErrors = true
        this.saved = false
      }).then(() => {
        this.$toast.success('Changes saved.')
        this.hasErrors = false
        this.errors = {}
        this.saved = true
        this.$emit('refresh')
        setTimeout(() => {
          this.saved = false
        }, 500)
      }).catch(() => {
        this.$toast.error('Failed to save information...')
      })
    },
    formatPercent (value) {
      return (+value / 100).toFixed(2) + '%'
    },
  },
  computed: {
    buyerTransactionInfoComplete () {
      if (this.data.buyer &&
              typeof (this.data.sale_price_cents) === 'number' &&
              typeof (this.data.auction_fee_cents) === 'number' &&
              typeof (this.data.conditioning_fee_cents) === 'number' &&
              typeof (this.data.repair_cost_cents) === 'number' &&
              typeof (this.data.tow_fee_cents) === 'number') return true
      return false
    },
    errorDisplay1098 () {
      if (!this.data.proceeds_distributed && !this.data.has_valid_ssn) {
        return 'Cannot send 1098 until proceeds have been distributed and donor has valid tax ID'
      } else if (!this.data.can_send_1098) {
        if (this.data.sale_price_cents < 50000) return 'Cannot send 1098 if sales price is below $500'
        else return 'Cannot send 1098 without a valid SSN / Tax Id'
      } else return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.spacing-block {
    margin-top: 3em;
    margin-bottom: 2em;
}
.fade-enter-active, .fade-leave-active {
    opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transition: opacity 3s;
    opacity: 0;
}
  .field.columns {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    dl {
      width: 50%;
      margin: 0;
    }
  }

.disabled div {
    pointer-events: none;
    user-select: none;
}
.disabled div div {
  pointer-events: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Vehicle/VehicleDisposition.vue